module.exports = __webpack_public_path__ + "assets/img/lector-33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lectors/lector-33.png
// module id = 1961
// module chunks = 0